import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen, Gift, Sparkles } from 'lucide-react';
const guiaPrincipal = {
  tag: 'GUÍA PRINCIPAL',
  title: 'Freelance Express — La Guía Completa',
  desc: 'Cómo cobrar tus primeros $500 USD desde Argentina sin experiencia previa. Del salario estancado a la economía global: el manual del Arbitraje de Micro-tareas potenciado con IA.'
};
const ebooks = [{
  num: 1,
  title: 'Descripciones de Amazon/Shopify con IA',
  desc: 'Creá textos que venden en minutos sin ser copywriter. Tu guía completa para ofrecer servicios de copywriting e-commerce y cobrar en USD.',
  details: '20 módulos · Estrategia + Plantillas + Ejemplos'
}, {
  num: 2,
  title: 'Subtítulos para Reels/TikTok con IA',
  desc: 'Editá captions dinámicos que aumentan retención y vendelo como freelancer. Guía práctica de $0 a $500/mes.',
  details: 'Edición 2026 · Paso a paso completo'
}, {
  num: 3,
  title: 'Remoción de Fondos y Edición de Fotos de Producto con IA',
  desc: 'Prepará imágenes profesionales para e-commerce y vendelo como freelancer. Con herramientas gratuitas y perfil de Fiverr optimizado.',
  details: 'Edición 2026 · Herramientas gratuitas incluidas'
}, {
  num: 4,
  title: 'Traducción ES↔EN con DeepL + IA',
  desc: 'Traducí textos profesionales rápido y vendelo como freelancer. Construí un servicio de traducción asistida por IA, sin ser traductor certificado.',
  details: 'Edición 2026 · Español LATAM'
}, {
  num: 5,
  title: 'De YouTube a Blog con IA',
  desc: 'Convertí videos en artículos SEO que atraen tráfico y vendelo como freelancer. Sin ser periodista, sin ser experto SEO, sin experiencia previa.',
  details: 'Edición 2026 · Español LATAM'
}];
const bonuses = ['El Triángulo de Cobro Anti-Cepo: El sistema exacto para cobrar tus dólares y recibirlos en pesos al valor real (Blue/MEP) sin que el banco te quite nada.', 'Estrategia del Francotirador: Cómo escribir propuestas que cierren contratos aunque nunca hayas trabajado para afuera.', 'Checklist del Perfil Imán: Cómo configurar tus cuentas para que los clientes te busquen a vos.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function OfferStack() {
  return <section className="py-24 px-4" data-id="element-103">
      <div className="max-w-5xl mx-auto" data-id="element-104">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-105">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-106">
            Mirá todo lo que te llevás{' '}
            <span className="text-emerald-400" data-id="element-107">hoy</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-108">
            6 ebooks completos + bonus exclusivos. Una colección diseñada para
            que empieces a facturar en dólares con 5 micro-tareas reales.
          </p>
        </motion.div>

        {/* Collection Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 relative" data-id="element-109">
          <div className="max-w-2xl mx-auto" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/beg6pdjWHUVyVFohd6hkvx/ChatGPT_Image_3_mar_2026,_07_47_26_p.m..png" alt="Colección Completa Freelance Express - 6 ebooks" className="w-full h-auto rounded-2xl drop-shadow-[0_20px_60px_rgba(16,185,129,0.2)]" data-id="element-111" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-[#111827] via-transparent to-transparent pointer-events-none rounded-2xl" data-id="element-112" />
        </motion.div>

        {/* Guía Principal */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-6" data-id="element-113">
          <div className="bg-gradient-to-r from-emerald-900/30 to-blue-900/20 border-2 border-emerald-500/40 p-6 md:p-8 rounded-2xl relative overflow-hidden" data-id="element-114">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-500 via-emerald-400 to-blue-400" data-id="element-115" />
            <div className="flex items-start gap-4 md:gap-6" data-id="element-116">
              <div className="mt-1 shrink-0" data-id="element-117">
                <div className="bg-emerald-500/20 p-2 rounded-xl" data-id="element-118">
                  <BookOpen className="w-7 h-7 md:w-8 md:h-8 text-emerald-400" data-id="element-119" />
                </div>
              </div>
              <div data-id="element-120">
                <span className="inline-block px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-400 text-xs font-bold uppercase tracking-widest mb-3" data-id="element-121">
                  {guiaPrincipal.tag}
                </span>
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-122">
                  {guiaPrincipal.title}
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-123">
                  {guiaPrincipal.desc}
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* 5 Micro-tareas */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-4 mb-10" data-id="element-124">
          {ebooks.map(ebook => <motion.div key={ebook.num} variants={itemVariants} className="bg-gradient-to-r from-[#111827] to-[#0d1321] border border-emerald-900/30 p-6 md:p-8 rounded-2xl flex items-start gap-4 md:gap-6 hover:border-emerald-500/50 transition-colors group" data-id="element-125">
              <div className="mt-1 shrink-0" data-id="element-126">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center text-emerald-400 font-black text-lg md:text-xl group-hover:bg-emerald-500/20 transition-colors" data-id="element-127">
                  {ebook.num}
                </div>
              </div>
              <div data-id="element-128">
                <span className="text-emerald-500/70 text-xs font-bold uppercase tracking-widest" data-id="element-129">
                  Micro-Tarea {ebook.num}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mb-2 mt-1" data-id="element-130">
                  {ebook.title}
                </h3>
                <p className="text-gray-400 leading-relaxed mb-2" data-id="element-131">
                  {ebook.desc}
                </p>
                <span className="text-xs text-emerald-500/60 font-medium" data-id="element-132">
                  {ebook.details}
                </span>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Bonuses */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12" data-id="element-133">
          <div className="flex items-center gap-3 mb-6" data-id="element-134">
            <Gift className="w-6 h-6 text-yellow-400" data-id="element-135" />
            <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-136">
              Y además te llevás estos{' '}
              <span className="text-yellow-400" data-id="element-137">BONUS</span> incluidos:
            </h3>
          </div>
          <div className="space-y-3" data-id="element-138">
            {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-yellow-500/5 border border-yellow-500/20 p-5 rounded-xl flex items-start gap-4" data-id="element-139">
                <CheckCircle2 className="w-6 h-6 text-yellow-400 shrink-0 mt-0.5" data-id="element-140" />
                <p className="text-gray-300 leading-relaxed" data-id="element-141">{bonus}</p>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Total Summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-142">
          <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-emerald-500/10 border border-emerald-500/30" data-id="element-143">
            <Sparkles className="w-5 h-5 text-emerald-400" data-id="element-144" />
            <span className="text-emerald-400 font-bold text-lg" data-id="element-145">
              6 ebooks + 3 bonus = Tu kit completo para facturar en dólares
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}